import React, { forwardRef } from 'react'

import cn from 'classnames'
import { useTranslation } from 'react-i18next'

import { CONTACTS_KEY_PREFIX } from '../../InnoscriptaContacts.constants'
import type { ContactResponsible } from '../../InnoscriptaContacts.types'
import defaultAvatar from '../../assets/default-avatar.jpg'
import styles from './ContactsTrigger.module.scss'

interface ContactsTriggerProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isOpen: boolean
  mainContact: ContactResponsible
}

export const ContactsTrigger = forwardRef<
  HTMLButtonElement,
  ContactsTriggerProps
>(({ isOpen, mainContact, className, ...rest }, ref) => {
  const { t } = useTranslation('translation', {
    keyPrefix: CONTACTS_KEY_PREFIX
  })

  const { user } = mainContact

  return (
    <button
      {...rest}
      ref={ref}
      type='button'
      data-testid='contacts-trigger'
      className={cn(styles.contactsTrigger, className, {
        [styles.open]: isOpen
      })}
      aria-haspopup='dialog'
      aria-expanded={isOpen}
    >
      <img
        className={styles.avatar}
        src={user.avatar ?? defaultAvatar}
        alt={user.name}
      />

      <span className={styles.details}>
        <span className={styles.name}>{user.name}</span>
        <span className={styles.caption}>{t('your_main_contact')}</span>
      </span>
    </button>
  )
})

ContactsTrigger.displayName = 'ContactsTrigger'
